import React from "react";
import { Boxes, ShieldCheck, Ticket, Store, Smartphone, Wrench } from "lucide-react";

const clients = [
  { name: "KYC360", icon: ShieldCheck },
  { name: "MyMor", icon: Boxes },
  { name: "Himachal Gramin Hut", icon: Store },
  { name: "Ticket Booking System", icon: Ticket },
  { name: "Services App", icon: Smartphone },
  { name: "Service Lane", icon: Wrench },
];

const Chip = ({ name, icon: Icon }) => (
  <div className="mx-3 inline-flex items-center gap-3 whitespace-nowrap rounded-2xl glass px-6 py-4 grayscale opacity-60 hover:grayscale-0 hover:opacity-100 hover:bg-white/[0.07] transition-all duration-300">
    <span className="h-9 w-9 rounded-xl bg-gradient-to-br from-blue-500 to-violet-500 grid place-items-center">
      <Icon className="h-4 w-4 text-white" strokeWidth={2.3} />
    </span>
    <span className="font-display text-lg text-white">{name}</span>
  </div>
);

export const Clients = () => {
  const row = [...clients, ...clients];
  return (
    <section id="clients" className="relative bg-[#070b18] py-24 overflow-hidden">
      <div className="absolute top-0 left-1/3 w-[440px] h-[300px] rounded-full bg-blue-700/10 blur-[130px]" />
      <div className="relative">
        <div className="max-w-6xl mx-auto px-4 text-center mb-14">
          <span className="eyebrow reveal">Our Clients</span>
          <h2 className="reveal d1 mt-5 font-display text-white text-3xl md:text-5xl">
            Brands &amp; teams we've <span className="text-gradient">delivered for</span>
          </h2>
          <p className="reveal d2 mt-4 text-slate-400 text-base md:text-lg max-w-2xl mx-auto">
            Real products, shipped for real businesses across web, mobile and cloud.
          </p>
        </div>

        {/* Row 1 */}
        <div className="marquee-mask">
          <div className="marquee-track">
            {row.map((c, i) => (
              <Chip key={`a-${i}`} {...c} />
            ))}
          </div>
        </div>

        {/* Row 2 (reverse) */}
        <div className="marquee-mask mt-5">
          <div className="marquee-track" style={{ animationDirection: "reverse", animationDuration: "34s" }}>
            {row.map((c, i) => (
              <Chip key={`b-${i}`} {...c} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
